var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#56ABFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8021 14.2745L20.8017 14.2754C21.636 15.3394 22.1347 16.6871 22.1347 18.1528C22.1347 19.6404 21.6211 21.0064 20.7643 22.0776L20.6906 22.1698L20.671 22.0526C20.6543 21.9529 20.6348 21.8522 20.6121 21.7508C20.1833 19.8345 18.7862 18.1914 16.4868 16.8609C14.934 15.9649 14.0452 14.886 13.8118 13.6602C13.6611 12.8676 13.7732 12.0714 13.9897 11.3895C14.2061 10.7078 14.5282 10.1366 14.8017 9.79271L15.6964 8.68003C15.8532 8.48494 16.1468 8.48494 16.3037 8.68003L20.8021 14.2745ZM22.2169 13.163L16.2216 5.70638C16.1072 5.56402 15.8928 5.56402 15.7784 5.70638L9.78287 13.1627L9.76352 13.1877C8.66024 14.5802 8 16.3498 8 18.2761C8 22.7625 11.5816 26.3996 16 26.3996C20.4184 26.3996 24 22.7625 24 18.2761C24 16.3498 23.3398 14.5802 22.2365 13.1877L22.2169 13.163ZM11.2174 14.2505L11.7539 13.5832L11.7701 13.7063C11.783 13.8039 11.7985 13.9019 11.817 14.0004C12.164 15.852 13.4035 17.396 15.4758 18.5918C17.2772 19.6345 18.326 20.8336 18.6282 22.1487C18.7543 22.6975 18.7768 23.2375 18.7222 23.7096L18.7188 23.7388L18.6928 23.7517C17.8798 24.1557 16.9658 24.3824 15.9998 24.3824C12.6117 24.3824 9.86501 21.5935 9.86501 18.1528C9.86501 16.6756 10.3714 15.3183 11.2174 14.2505Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/sui.263dac2acd14b96746e7f653de0e12f2.svg";
export { ForwardRef as ReactComponent };